import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-provider-earnings-card",
  templateUrl: "./provider-earnings-card.component.html",
  styleUrls: ["./provider-earnings-card.component.scss"],
  standalone: false,
})
export class ProviderEarningsCardComponent {
  @Input() balance: number = 0;
  @Input() pendingAmount: number = 0;
  @Input() trendPercent: number = 12;
  @Input() trendLabel: string = "PROVIDER.EARNINGS.TREND_LABEL";
  @Input() title: string = "PROVIDER.EARNINGS.TITLE";
  @Input() pendingLabel: string = "PROVIDER.EARNINGS.PENDING_AMOUNT";
  @Output() cardClick = new EventEmitter<void>();

  constructor(private translate: TranslateService) {}

  get absTrend(): number {
    return Math.abs(this.trendPercent);
  }

  get amountMajor(): string {
    const abs = Math.abs(this.balance || 0);
    const major = Math.floor(abs);
    return major.toString();
  }

  get amountCents(): string {
    const abs = Math.abs(this.balance || 0);
    const cents = Math.round((abs - Math.floor(abs)) * 100);
    return cents.toString().padStart(2, "0");
  }

  get isNegativeBalance(): boolean {
    return (this.balance || 0) < 0;
  }

  get isPositiveTrend(): boolean {
    return this.trendPercent >= 0;
  }

  get titleText(): string {
    return this.translate.instant(this.title);
  }

  get pendingLabelText(): string {
    return this.translate.instant(this.pendingLabel);
  }

  get formattedPendingAmount(): string {
    const value = Math.max(0, this.pendingAmount || 0);
    return (
      new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value) + " €"
    );
  }

  get trendLabelText(): string {
    return this.translate.instant(this.trendLabel);
  }

  onCardClick(): void {
    this.cardClick.emit();
  }
}
